import { render, staticRenderFns } from "./MessageContentEmail.vue?vue&type=template&id=01b2c9d6"
import script from "./MessageContentEmail.vue?vue&type=script&lang=js"
export * from "./MessageContentEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports